export default __webpack_public_path__ + "static/sol-k12-section-1-img-e195ba6a07814d85379ffe45819f143c.jpg";